import { SelectNewIntegrationTypeCard } from '@modules/integrationsV2/components/SelectNewIntegrationTypeDrawer';
import { useIsCreateCustomGroupsEnabled } from '@modules/integrationsV2/hooks';
import { useIntegrationsStore } from '@modules/integrationsV2/store/integrationsStore';
import { Stack } from '@mui/material';
import {
  IntegrationChannelType,
  IntegrationFormDataViewFragment,
  IntegrationType,
} from 'generated/graphql';

interface SelectNewIntegrationTypeDrawerContentProps {
  integrationFormData: IntegrationFormDataViewFragment[];
}

export const SelectNewIntegrationTypeDrawerContent = ({
  integrationFormData,
}: SelectNewIntegrationTypeDrawerContentProps) => {
  const isCreateCustomGroupsEnabled = useIsCreateCustomGroupsEnabled();

  const selectedIntegrationToConnect = useIntegrationsStore(
    ({ view }) => view.selectedIntegrationToConnect,
  );

  const shouldShowCustomGroupType =
    selectedIntegrationToConnect?.integrationChannel.type ===
      IntegrationChannelType.FileUpload && isCreateCustomGroupsEnabled;

  return (
    <Stack spacing={4} p={4}>
      <SelectNewIntegrationTypeCard
        integrationType={IntegrationType.Feedback}
        integrationFormData={integrationFormData}
      />
      <SelectNewIntegrationTypeCard
        integrationType={IntegrationType.User}
        integrationFormData={integrationFormData}
      />
      <SelectNewIntegrationTypeCard
        integrationType={IntegrationType.Account}
        integrationFormData={integrationFormData}
      />
      {shouldShowCustomGroupType && (
        <SelectNewIntegrationTypeCard
          integrationType={IntegrationType.Cohorts}
          integrationFormData={integrationFormData}
        />
      )}
    </Stack>
  );
};
